import React, { useRef, useState } from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import axios from 'axios';
import {
    validaSoloNumero, formatMoneda, validaMonto, formatoMonto, validaNumeroTelefono, validaEmail
} from '../../util/varios';
import CatalogoPersona from '../../catalogos/catalogoPersona';
import { Mensaje, MensajeSiNo } from '../mensajes';
import useTable from "../../components/useTable";
import { TableBody, TableRow, TableCell } from '@material-ui/core';

export const GestionarProducto = (props) => {

    const headCells = [
        { id: '', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'COD.', textAlign: 'center' },
        { id: '', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' },
        { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
    ]

    let token = sessionStorage.getItem('jwtToken');
    let op = require('../../../public/modulos/datos');
    let anio = JSON.parse(sessionStorage.getItem('anioactu'))
   // const fechaTope = moment(JSON.parse(sessionStorage.getItem('fechasistema'))).format('YYYY-MM-DD').replace(anio.toString(), (anio - 18).toString());
    const deshabilitado = false;

    /*  variables de referencias */
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtCodAlmacen = useRef();
    const txtDescripcion = useRef();
    const cmbAlmacen = useRef();
    const txtBuscador = useRef();



    /*  variables de estados */
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [catalogo, setCatalogo] = useState(false)
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState('0');
    const [habilitadoNU, setHabilitadoNU] = useState(true);
    const [operacionPer, setOperacionPer] = useState(0);
    const [observacion, setObservacion] = useState('hidden');
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const [municipios, setMunicipios] = useState()
    const [ciudades, setCiudades] = useState()
    const [mostrar, setMostrar] = useState(false);
    const [body, setBody] = useState(null);
    const [records, setRecords] = useState([
        {
            codigo: 1,
            nombre: 'JESUS',
            descripcion: 'ALMACEN 1'
        }
    ]);
    const [values, setValues] = useState({
        cedula: '',
        correoe: '',
        tlf1: '',
        tlf2: '',
        apellidos: '',
        direccion: '',
        fnacimiento: '',
        nacionalidad: '',
        nombres: '',
        nombres: ''
    });

    const onChange2 = (e) => {

        if (e.target.name === 'descripcion') {
            e.target.value = e.target.value.toUpperCase();
        }


    }

    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
        TblPagination
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;
        let st = '';
        setFilterFn({
            fn: items => {
                if (target.value === "")
                    return items;
                else
                    return items.filter(x => {
                        (st = x.status === '51' ? 'activo' : 'inactivo')
                        if (x.idagente.includes(target.value)
                            || x.nombre.toLowerCase().includes(target.value.toLowerCase())
                            || x.rif.toLowerCase().includes(target.value.toLowerCase())
                            || x.nrolicencia.toLowerCase().includes(target.value.toLowerCase())
                            || st.toLowerCase().includes(target.value.toLowerCase())
                        ) {
                            return x;
                        }
                    });
            }
        })

    }


    const handleInputNumChange = (event) => {
        event.preventDefault();
        validaSoloNumero(event);
        var valido;
        if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };

    const handleInputMontoChange = (event) => {
        validaMonto(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
                event.target.value = '0,00'
            }
            event.target.value = (formatoMonto(event.target.value));
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === '0' && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const onChangeValidar = (e) => {
        e.preventDefault();

        let sigue = true;
        if (operacion === 1 || operacion === 2) {

            if (txtDescripcion.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar una descripción al Almacen', icono: 'informacion' });
                txtDescripcion.current.focus()
                sigue = false
            }

        }
        if (sigue) {


            let msg = '';
            if (props.operacion === 1) {
                msg = 'Esta Seguro de Registrar estos Datos.';
            } else if (props.operacion === 2) {
                msg = 'Esta Seguro de Modificar estos Datos.';
            } else if (props.operacion === 3) {
                msg = 'Esta Seguro de Eliminar estos Datos.';
            }

            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
        }
    }

    const procesarRegistro = () => {

    }

    const blanquear = () => {
        setActivate(false);
        setValues({});
        setOperacion(0);
    }

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        procesarRegistro();
    };

    const cancelar = (e) => {
        setOperacion('0')
        e.preventDefault();
        blanquear();
        props.onHideCancela();

    }


    const onChange = (e) => {

        if (e.target.name === 'almacen' || e.target.name === 'descripcion') {
            e.target.value = e.target.value.toUpperCase();
        }
        setValues({ ...values, [e.target.name]: e.target.value })


    }

    const gestionarExpendedor = (op, id) => (e) => {

        setOperacion(op);

    }

    const cerrarModal = () => {
        if (props.llamado === 2) {
            props.onHideRenderizar();
            props.onHideCancela();
        }
        blanquear();
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
    }

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
            }}

        >
            <Modal.Header className='azulGradiant2 header-modal'>
                <Modal.Title style={{ color: "#fff" }}>Gestionar Tipo Producto.</Modal.Title>
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#FFF" }}>



                <Mensaje mensaje={mensaje}
                    onHide={() => {
                        mensaje.titulo === 'Exito.' ?
                            cerrarModal() :
                            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                    }
                    } />
                <MensajeSiNo mensaje={mensajesino}
                    onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
                <Dimmer active={activate} inverted>
                    <Loader inverted>cargando...</Loader>
                </Dimmer>
                <div className='border-azul py-3 rounded'>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif' }}>

                        {operacion.toString() === '0' ?
                            <div className='col-md-12 mx-auto'>

                                <div className="col-12 p-2">
                                    <div className="row col-12 d-flex justify-content-between">
                                        <input type="text" className=" col-3 form-control form-control-sm rounded-pill" ref={txtBuscador} onChange={handleSearch} placeholder="Buscar" />
                                        <div className='col-3 d-flex justify-content-end'>
                                            <button onClick={gestionarExpendedor(1, '')} style={{ marginBottom: "5px" }} className="btn btn-sm btn-primary rounded-circle"><i className="fas fa-plus"></i> </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12" style={{ margin: "auto" }} >
                                    <TblContainer>
                                        <TblHead />
                                        <TableBody >
                                            {
                                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                                    <TableRow key={index} style={{ padding: "0" }}>
                                                        <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>{item.codigo}</TableCell>
                                                        <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '270px' }}>{item.descripcion}</TableCell>
                                                        <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>
                                                            <button onClick={gestionarExpendedor(4, item.codigo)} className="btn btn-sm mx-1 btn-info rounded-circle" ><i className="fas fa-eye"></i> </button>
                                                            <button onClick={gestionarExpendedor(2, item.codigo)} className="btn btn-sm mx-1 btn-warning rounded-circle"><i className="fa fa-edit"></i> </button>
                                                            <button onClick={gestionarExpendedor(3, item.codigo)} className="btn btn-sm mx-1 btn-danger rounded-circle"><i className="fa fa-trash"></i> </button>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            }
                                        </TableBody>
                                    </TblContainer>
                                    <TblPagination />
                                </div>
                            </div>

                            :
                            <div className="row rounded mx-auto justify-content-between">

                                <div className="input-group input-group-sm mb-2 col-md-3">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Código:</label>
                                    <input type="text" ref={txtCodAlmacen} disabled className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>
                                <div className='col-md-3 d-flex justify-content-end'>
                                    <button className="btn btn-sm mx-1 btn-primary rounded-pill" onClick={gestionarExpendedor(0, '')} style={{ height: '27px' }} title='Volver a la Tabla'><i style={{ fontSize: '9px' }} className="fas fa-long-arrow-alt-left"> Volver </i> </button>

                                </div>
                                <div className="input-group input-group-sm mb-2 col-md-12">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Nombre:</label>
                                    <input type="text" ref={txtDescripcion} name='descripcion' className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onChange={onChange2} />
                                </div>

                                {/*   <div className='col-md-12'>
                                 <fieldset className=' row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between'>
                                     <legend className="float-none w-auto fw-bold" style={{ fontSize: '15px' }}>Cuenta Clasificador Presupuestario</legend>

                                     <div className="input-group input-group-sm col-md-4">
                                     
                                         <div className=" col px-0">
                                             <span for="exampleInputEmail1" className="form-label text-center">Ramo</span>
                                             <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"/>
                                         
                                         </div>
                                         <div className=" col px-0">
                                             <span for="exampleInputEmail1" className="form-label text-center">Gen</span>
                                             <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"/>
                                         
                                         </div>
                                         <div className=" col px-0">
                                             <span for="exampleInputEmail1" className="form-label text-center">Espec</span>
                                             <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"/>
                                         
                                         </div>
                                         <div className=" col px-0">
                                             <span for="exampleInputEmail1" className="form-label text-center">SubEsp</span>
                                             <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"/>
                                         
                                         </div>
                                         <div className='col'>
                                         <button type="button" onClick={cerrarcatalogo} className="btn btn-success mt-4"><i className="fas fa-search"></i></button>
                                         </div>

                                     
                                     </div>

                                     
                                     <div className="input-group input-group-sm col">
                                         <label className="input-group-text" id="inputGroup-sizing-sm">Descripción:</label>
                                         <textarea type="area" className="form-control h-100" name='' aria-label="Sizing example input"  aria-describedby="inputGroup-sizing-sm" />
                                     </div>

                                 



                                 
                                 </fieldset>
                             </div>
                             <div className='col-md-6 mt-2'>
                                 <fieldset className=' row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between'>
                                     <legend className="float-none w-auto fw-bold" style={{ fontSize: '15px' }}>Cuenta Contable</legend>

                                     <div className="input-group input-group-sm col-md-12">
                                         <label className="input-group-text" id="inputGroup-sizing-sm">Código Cuenta Contable:</label>
                                         <input type="text"  disabled className="form-control col-md-2" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                         <button type="button" onClick={cerrarcatalogo} className="btn btn-success"><i className="fas fa-search"></i></button>
                                         <input type="text"  disabled className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                     </div>

                                     
                                 

                                 



                                 
                                 </fieldset>
                             </div> */}
                                <div className='col-md-11 mx-auto row d-flex justify-content-end px-2'>
                                    <div className='col-md-8 py-1 row border-azul rounded'>
                                        <label className="col" style={{ fontSize: '15px' }}>Producto Informatico</label>

                                        <div className='col-md-2'>
                                            <div className="form-check col-md-12">
                                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                                <label className="form-check-label py-1" for="flexRadioDefault1">
                                                    Si
                                                </label>
                                            </div>
                                        </div>
                                        <div className='col-md-2'>
                                            <div className="form-check col-md-12">
                                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                                <label className="form-check-label py-1" for="flexRadioDefault1">
                                                    No
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>





                            </div>
                        }




                    </div>
                </div>
            </Modal.Body >
            <Modal.Footer>
                <button ref={btnAcepta} disabled={operacion === 4 ? true : false} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-success "><i className="fas fa-check-circle">  Aceptar</i></button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill "><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal >
    );
}




// WEBPACK FOOTER //
// ./src/components/almacen/gestionarProducto.js